<div [ngClass]="type">
    <div *ngIf="!readOnly" class="form-row">
        <ng-content select="div[role=header]"></ng-content>
        <div *ngIf="groupArray.length>0" class="form-group inline-control compact">
            <label>{{groupByPlaceHolder}}</label>
            <select [(ngModel)]="selectedGroup" id="{{getId(groupByPlaceHolder)}}">
                <option *ngFor="let item of groupArray" [ngValue]="item">
                    {{item}}
                </option>
            </select>
        </div>
        <div class="form-group inline-control compact">
            <label *ngIf="groupArray.length>0">{{infoLabel}}</label>
            <input [(ngModel)]="selectedInfo" id="{{getId(infoLabel)}}" type="text" maxlength="25" [disabled]="readOnly">
           &nbsp;
            <button type="button" class="compact" (click)="onComboAdd()" [disabled]="readOnly">
                <span class="icon-plus"></span> {{acceptText}}
            </button>
        </div>

    </div>
    <div *ngIf="OrderedList && !readOnly" class="warning info">* To reorder drag and drop your {{infoLabel}}.</div>
    <ng-content select="ul[role=list]"></ng-content>
    <table role="list" class="condensed">
        <thead>
            <tr>
                <th *ngFor="let column of columns">{{column}}</th>
                <th><span class="offscreen"></span></th>
            </tr>
        </thead>
        <tbody *ngIf="OrderedList && !readOnly" cdkDropList (cdkDropListDropped)="drop($event)">
            <tr *ngFor="let row of rows" class="compact" cdkDrag>
                <td><span>{{row.order == 0 ? '': row.order}}</span></td>
                <td *ngIf="groupArray.length>0">
                    <div>{{row.groupby}}</div>
                </td>
                <td>
                    <div> {{ row.displayValue }}</div>
                </td>
                <td><button *ngIf="!readOnly" type="button" class="compact" id="{{ row.displayValue}}"
                        (click)="onComboRemove(row)" [disabled]="readOnly"><span class="icon-bin"></span>
                        Remove</button></td>
            </tr>
        </tbody>
        <tbody *ngIf="!OrderedList || readOnly">
            <tr *ngFor="let row of rows" class="compact">
                <td><span>{{row.order == 0 ? '': row.order}}</span></td>
                <td *ngIf="groupArray.length>0">
                    <div>{{row.groupby}}</div>
                </td>
                <td>
                    <div> {{ row.displayValue }}</div>
                </td>
                <td><button *ngIf="!readOnly" type="button" class="compact" id="{{ row.displayValue}}"
                        (click)="onComboRemove(row)" [disabled]="readOnly"><span class="icon-bin"></span>
                        Remove</button></td>
            </tr>
        </tbody>
    </table>
</div>
